import { z } from "zod";
const configurationTestResultIdSchema = z.uuid().brand();
function asConfigurationTestResultId(id) {
  return configurationTestResultIdSchema.parse(id);
}
const configurationTestResultResourceTypes = ["playbook"];
const configurationTestResultResourceTypeSchema = z.enum(
  configurationTestResultResourceTypes
);
export {
  asConfigurationTestResultId,
  configurationTestResultIdSchema,
  configurationTestResultResourceTypeSchema,
  configurationTestResultResourceTypes
};
//# sourceMappingURL=configurationTestResult.js.map
